import Vue from 'vue'

export const store = Vue.observable({
  activeModalFirstLogin: false
})
export const mutation = {
  setActiveModalFirstLogin: (activeModal) => {
    store.activeModalFirstLogin = activeModal
  }
}